// Generates an easy-to-remember 4-digit password.
// Patterns: AAAx (e.g., 1117), AABB (e.g., 1122), ABB0 (e.g., 3990)
export function generateEasy4DigitPassword(): string {
  const randomInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;

  const pickDigit = (exclude?: number): number => {
    let d = randomInt(0, 9);
    while (d === exclude) {
      d = randomInt(0, 9);
    }
    return d;
  };

  // Ensure first digit is not 0 for readability
  const pickFirstDigit = (exclude?: number): number => {
    let d = randomInt(1, 9);
    while (d === exclude) {
      d = randomInt(1, 9);
    }
    return d;
  };

  type Pattern = 'AAAx' | 'AABB' | 'ABB0';
  const patterns: Pattern[] = ['AAAx', 'AABB', 'ABB0'];
  const pattern = patterns[randomInt(0, patterns.length - 1)];

  let a = 0; let b = 0; let x = 0;
  switch (pattern) {
    case 'AAAx': {
      a = pickFirstDigit();
      x = pickDigit(a);
      return `${a}${a}${a}${x}`;
    }
    case 'AABB': {
      a = pickFirstDigit();
      b = pickDigit(a);
      return `${a}${a}${b}${b}`;
    }
    case 'ABB0':
    default: {
      a = pickFirstDigit();
      // Favor 9 for the pair to create patterns like 3990, but allow variance
      b = Math.random() < 0.6 ? 9 : pickDigit(a);
      return `${a}${b}${b}0`;
    }
  }
}


